/**
 * @generated SignedSource<<df3a0736354f96c77cc61c4514f62899>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespTabsCustomizationPanel_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactDealerButton_user">;
  readonly " $fragmentType": "PdpRespTabsCustomizationPanel_user";
};
export type PdpRespTabsCustomizationPanel_user$key = {
  readonly " $data"?: PdpRespTabsCustomizationPanel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespTabsCustomizationPanel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespTabsCustomizationPanel_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b7c1f4eb856f710e92053f6787b22bf6";

export default node;
